/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppCalendarQueryVariables = {
    orgRelayId: string;
    weekStartDates: Array<unknown>;
    calendarIds: Array<string>;
    timeZone: string;
};
export type WebAppCalendarQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"WebAppCalendar_viewer">;
    };
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"WebAppCalendar_org">;
    } | null;
};
export type WebAppCalendarQuery = {
    readonly response: WebAppCalendarQueryResponse;
    readonly variables: WebAppCalendarQueryVariables;
};



/*
query WebAppCalendarQuery(
  $orgRelayId: ID!
  $weekStartDates: [LocalDate!]!
  $calendarIds: [String!]!
  $timeZone: String!
) {
  viewer {
    ...WebAppCalendar_viewer
    id
  }
  org: node(id: $orgRelayId) {
    __typename
    ...WebAppCalendar_org_iRe5i
    id
  }
}

fragment WebAppCalendar_org_iRe5i on Org {
  eventParentBaseWrapperByWeeksObject(weekStartDates: $weekStartDates, calendarIds: $calendarIds, includeAllDay: true, timeZone: $timeZone) {
    __typename
    ... on EventParentBaseWrapperByWeekObjectList {
      list {
        eventParentBases {
          id
          timestamp
        }
        eventParentsByDay {
          eventParents {
            id
            eventParentBaseId
            eventParentBaseTimestamp
            events {
              title
              locked
              isClockwiseEvent
              isAllDay
              calendarIds
              organizer {
                urnValue
                responseStatus
              }
              attendees {
                urnValue
                responseStatus
              }
              creator {
                urnValue
              }
              annotatedEvent {
                userTags {
                  tag
                  states {
                    subjectType
                    subjectValue
                    value
                  }
                }
                orgTags {
                  tag
                  state {
                    subjectType
                    subjectValue
                    value
                  }
                }
                id
              }
              eventKey {
                externalEventId
                id
              }
              location
              startTime {
                dateOrDateTime
                millis
              }
              endTime {
                dateOrDateTime
                millis
              }
            }
          }
        }
      }
    }
  }
  userWorkingHours {
    id
    workingHours {
      daySettings {
        day
        setting {
          minSlot
          maxSlot
        }
      }
      id
    }
  }
}

fragment WebAppCalendar_viewer on Viewer {
  user {
    id
    emails
    webAppFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "weekStartDates"
    } as any, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v5 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v6 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v7 = {
        "kind": "Variable",
        "name": "weekStartDates",
        "variableName": "weekStartDates"
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v11 = [
        (v10 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v13 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v14 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebAppCalendarQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WebAppCalendar_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "WebAppCalendar_org"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "WebAppCalendarQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v8 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "emails",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v9 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v8 /*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v8 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        (v8 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "includeAllDay",
                                            "value": true
                                        },
                                        (v6 /*: any*/),
                                        (v7 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "eventParentBaseWrapperByWeeksObject",
                                    "plural": false,
                                    "selections": [
                                        (v9 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventParentBaseWrapperByWeekObject",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventParentBase",
                                                            "kind": "LinkedField",
                                                            "name": "eventParentBases",
                                                            "plural": true,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "timestamp",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventParentsForDay",
                                                            "kind": "LinkedField",
                                                            "name": "eventParentsByDay",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventParent",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventParents",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "eventParentBaseId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "eventParentBaseTimestamp",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "events",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "locked",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isClockwiseEvent",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isAllDay",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarIds",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organizer",
                                                                                    "plural": false,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "attendees",
                                                                                    "plural": true,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "creator",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v10 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AnnotatedEvent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "annotatedEvent",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "UserTag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "userTags",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v12 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TagState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "states",
                                                                                                    "plural": true,
                                                                                                    "selections": (v13 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "OrgTag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "orgTags",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v12 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TagState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "state",
                                                                                                    "plural": false,
                                                                                                    "selections": (v13 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v8 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventKey",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "eventKey",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "externalEventId",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v8 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "location",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventTime",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "startTime",
                                                                                    "plural": false,
                                                                                    "selections": (v14 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventTime",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "endTime",
                                                                                    "plural": false,
                                                                                    "selections": (v14 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventParentBaseWrapperByWeekObjectList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "WorkingSetting",
                                                            "kind": "LinkedField",
                                                            "name": "setting",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "minSlot",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "maxSlot",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "337181b2b80dd29415b38a5c75d088f7",
            "id": null,
            "metadata": {},
            "name": "WebAppCalendarQuery",
            "operationKind": "query",
            "text": "query WebAppCalendarQuery(\n  $orgRelayId: ID!\n  $weekStartDates: [LocalDate!]!\n  $calendarIds: [String!]!\n  $timeZone: String!\n) {\n  viewer {\n    ...WebAppCalendar_viewer\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ...WebAppCalendar_org_iRe5i\n    id\n  }\n}\n\nfragment WebAppCalendar_org_iRe5i on Org {\n  eventParentBaseWrapperByWeeksObject(weekStartDates: $weekStartDates, calendarIds: $calendarIds, includeAllDay: true, timeZone: $timeZone) {\n    __typename\n    ... on EventParentBaseWrapperByWeekObjectList {\n      list {\n        eventParentBases {\n          id\n          timestamp\n        }\n        eventParentsByDay {\n          eventParents {\n            id\n            eventParentBaseId\n            eventParentBaseTimestamp\n            events {\n              title\n              locked\n              isClockwiseEvent\n              isAllDay\n              calendarIds\n              organizer {\n                urnValue\n                responseStatus\n              }\n              attendees {\n                urnValue\n                responseStatus\n              }\n              creator {\n                urnValue\n              }\n              annotatedEvent {\n                userTags {\n                  tag\n                  states {\n                    subjectType\n                    subjectValue\n                    value\n                  }\n                }\n                orgTags {\n                  tag\n                  state {\n                    subjectType\n                    subjectValue\n                    value\n                  }\n                }\n                id\n              }\n              eventKey {\n                externalEventId\n                id\n              }\n              location\n              startTime {\n                dateOrDateTime\n                millis\n              }\n              endTime {\n                dateOrDateTime\n                millis\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  userWorkingHours {\n    id\n    workingHours {\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment WebAppCalendar_viewer on Viewer {\n  user {\n    id\n    emails\n    webAppFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '06bbd05922357db4b780ec9a92c81f39';
export default node;
